// removed by extract-text-webpack-plugin
module.exports = {"carousel":"src-components-TestimonialsCarousel----styles-module---carousel---26xAP","hiddenTestimonial":"src-components-TestimonialsCarousel----styles-module---hiddenTestimonial---15QX0","clickable":"src-components-TestimonialsCarousel----styles-module---clickable---1XQRB","testimonial":"src-components-TestimonialsCarousel----styles-module---testimonial---17flX","inactive":"src-components-TestimonialsCarousel----styles-module---inactive---1xZTQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TestimonialsCarousel/styles.module.css
// module id = 512
// module chunks = 168707334958949